(ns teamoesterreich.admin-mode.crowdtasker.task.task-detail-form
  (:require [clojure.string]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.ui-helper.editable-markdown-card :as edit-md-card]
            [teamoesterreich.admin-mode.data.eventTask :as d-task]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.send :refer [send]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.util.date :as h-date]
            [teamoesterreich.util.markdown :refer [md]]))




(defn datetime-conv [dateTime]
  ;20180701T100000.000Z -> 2021-06-20T23:24
  (if (> (count dateTime) 12)
    (str (subs dateTime 0 4) "-" (subs dateTime 4 6) "-" (subs dateTime 6 8) "T" (subs dateTime 9 11) ":" (subs dateTime 11 13)
         )
    ""
    ))
(defn datetime-conv-back [dateTime]
  ;2021-06-20T23:24 -> 20180701T100000.000Z
  (str (subs dateTime 0 4) (subs dateTime 5 7) (subs dateTime 8 10) "T" (subs dateTime 11 13) (subs dateTime 14 16) "00.000Z"))

(defn get-base [!actual-task disabled]
  (let [!st (r/atom {:edit-mode false :data {}})
        !edit-mode (r/cursor !st [:edit-mode])
        !task-list-state (r/cursor vstate/app-state [:event :crowdtaskerTask-list-state :loaded])
        !data (r/cursor !st [:data])]
    (fn []
      (let [has-edit-right false
            changed? (fn [key]
                       (log/debug "changed?" key (exists? (get @!data key)) (not= (get @!data key) (get @!actual-task key)))
                       (and (exists? (get @!data key)) (not= (get @!data key) (get @!actual-task key))))
            has-changes? (or
                           (changed? :crowdtaskerTask-name)
                           (changed? :crowdtaskerTask-locationName)
                           (changed? :crowdtaskerTask-acceptableUntil)
                           (changed? :crowdtaskerTask-timeFrom)
                           (changed? :crowdtaskerTask-timeTo)
                           )
            change-fn (fn [key value] (swap! !data assoc key value))
            from-date (h-date/parse-service-date! (or (:crowdtaskerTask-timeFrom @!data) (:crowdtaskerTask-timeFrom @!actual-task)))
            to-date (h-date/parse-service-date! (or (:crowdtaskerTask-timeTo @!data) (:crowdtaskerTask-timeTo @!actual-task)))

            fromEventError (and from-date to-date (h-date/date>? from-date to-date))
            toEventError (and from-date to-date (h-date/date>? from-date to-date))
            fromError (and from-date to-date (h-date/date>? from-date to-date))
            ]
        [mui/card
         (log/debug "rerender form " @!data)
         [mui/card-header {:title "Online Einsatz Details"}]
         [mui/card-content
          [mui/grid
           {:container  true
            :direction  "row"
            :justify    "flex-start"
            :alignItems "flex-start"
            :spacing    3
            :style      {:margin "0"}
            }

           [mui/grid
            {:container false :item true
             :md 6
             :xs 12
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerTask-name) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerTask-name @!actual-task))
                             :onChange     (fn [e] (change-fn :crowdtaskerTask-name (h/event-value e)))
                             :label        "Aufgaben Name"}]
            ]
           [mui/grid
            {:container false :item true
             :md 6
             :xs 12
             :style {:padding "5px"}
             }
            [mui/text-field {
                             :style        {:backgroundColor (if (changed? :crowdtaskerTask-locationName) "#ffd6d2" "#ffffff")}
                             :fullWidth    true
                             :disabled     (not @!edit-mode)
                             :defaultValue (str (:crowdtaskerTask-locationName @!actual-task))
                             :onChange     (fn [e] (change-fn :crowdtaskerTask-locationName (h/event-value e)))
                             :label        "Aufgabe Ort"}]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerTask-timeFrom) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :label           "Beginn"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :crowdtaskerTask-timeFrom date)))
                             :defaultValue    (datetime-conv (:crowdtaskerTask-timeFrom @!actual-task))
                             :error fromError
                             :helperText (if fromError "ungültig (muss vor Einsatz Ende sein)" "")
                             }]
            ]
           [mui/grid
            {:container false :item true
             :md        3                                   ;medium: 960px
             :xs        12                                  ;extra-small: 0px
             :style     {:padding "5px"}
             }
            [mui/text-field {
                             :style           {:backgroundColor (if (changed? :crowdtaskerTask-timeTo) "#ffd6d2" "#ffffff")}
                             :fullWidth       true
                             :disabled        (not @!edit-mode)
                             :type            "datetime-local"
                             :label           "Ende"
                             :InputLabelProps {:disableAnimation true :shrink true}
                             :onChange        (fn [e]
                                                (let [date (h/event-value e)
                                                      date (datetime-conv-back date)]
                                                  (change-fn :crowdtaskerTask-timeTo date)))
                             :defaultValue    (datetime-conv (:crowdtaskerTask-timeTo @!actual-task))
                             :error fromError
                             :helperText (if fromError "ungültig (muss nach Einsatz Beginn)" "")
                             ;:InputProps {:startAdornment (r/as-element [mui/input-adornment {:position "start"} [cake]])}
                             }]
            ]
           ]
          [mui/card-actions
           (when (and (not @!edit-mode) (not disabled))
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [edit])
                          :onClick   #(reset! !edit-mode true)
                          } "Bearbeiten"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :startIcon (r/as-element [keyboard-arrow-left])
                          :onClick   #(reset! !edit-mode false)
                          } "Abbrechen"])

           (when (and @!edit-mode)
             [mui/button {
                          :variant   "contained"
                          :color     "primary"
                          :startIcon (r/as-element [save])
                          :disabled  (or (not has-changes?) fromError  )
                          :onClick (fn []
                                     (d-task/>task-save (:crowdtaskerTask-uuid @!actual-task) @!data
                                                        (fn [data]
                                                          (reset! !task-list-state false)
                                                          (reset! !actual-task data))))
                          } "Speichern"])

           ]
          ]

         ]))))

(defn get-description [!actual-task disabled]              ;; push/SMS
  (let [!state (r/atom {:show-send-me false})]
    (fn []
      (let [save-fn (fn [text]
                      (d-task/>task-save (:crowdtaskerTask-uuid @!actual-task) {:crowdtaskerTask-description text}
                                         (fn [data]
                                           (reset! !actual-task data))))]
        [:div
         (if disabled
           [:div
            [:h3 "Aufgabenbeschreibung (angezeigt vor der Annahme)"]
            [:div {:style {:border "1px dotted darkgrey"}} (get @!actual-task :crowdtaskerTask-description)]]
           [(edit-md-card/get-it (get @!actual-task :crowdtaskerTask-description) save-fn (str backend/BASE_URL "/media-upload") "Einsatzbeschreibung (angezeigt vor der Annahme)"
                                 "Textblöcke: #TOMID#,#VORNAME#,#NACHNAME#,#PREMAIL#,#PRHDY#,#PRHDY0#,#DIENSTSTELLE#, #ESTYP#,#KURZ#,#EVKURZ#,#ORT#,#BEGINN.SMS#,#BEGINN#,#DAUER#,#ENDE.SMS#,#ENDE#"
                                 )])]
        ))))


(defn get-it [!actual-task disabled]
  [mui/card-content {}
   [(get-base !actual-task disabled)]
   [:br]
   [(get-description !actual-task disabled)]
   [:br]
   ])